<template>
  <v-container fluid>
    <base-material-card
      id="card-params-rcp"
      color="primary"
      icon="$rcp"
      inline
      class="px-5 py-4 ml-0 mt-4"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Adicionar RCP
        </div>
      </template>
      <v-form class="pt-5">
        <v-row class="mx-auto">
          <v-col cols="12" class="pb-0">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-text-field
                id="nome-rcp"
                label="Nome do Relatório"
                outlined
                :error-messages="errors"
                v-model="nome"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mx-auto">
          <v-col cols="3" class="pt-1">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider v-slot="{ errors }" rules="required|min:7">
                  <v-text-field
                    id="data-base-rcp"
                    :error-messages="errors"
                    class="pt-0"
                    type="tel" v-mask="'##/####'"
                    v-model="monthFormatted"
                    label="Data Base AIS"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    outlined
                    v-on="on"
                    @blur="month = parseMonth(monthFormatted)"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                type="month"
                v-model="month"
                @input="menu = false; monthFormatted = formatMonth(month);"
                locale="pt-br"
              />
            </v-menu>
          </v-col>
        </v-row>
      </v-form>
    </base-material-card>
  </v-container>
</template>

<script>
import dayjs from 'dayjs';
import TabelasService from '@/services/TabelasService';

export default {
  data() {
    return {
      nome: "",
      menu: false,
      monthFormatted: "",
      month: ""
    }
  },

  mounted() {
    this.getUltimaDataBase();
  },

  methods: {
    parseMonth(date) {
      if (!date) return null;

      const [month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}`;
    },

    formatMonth(date) {
      if (date.length > 10) { date = date.substr(0, 10)};
      return dayjs(date).format('MM/YYYY');
    },

    getUltimaDataBase() {
      return TabelasService.getTabelaResumo()
        .then(response => {
          let data = response.data.tabela_resumo;
          
          this.month = data.data_base_ais ? data.data_base_ais : '';
          this.monthFormatted = data.data_base_ais ? this.formatMonth(data.data_base_ais+'-01') : '';
        })
        .catch(err => {
          this.$toast.error("Erro ao tentar pegar última data base", "", { position: "topRight"});
          console.error("Erro:", err);
        });
    },

    exportData() {
      return {
        nome: this.nome,
        data_base: this.month+'-01'
      };
    },
  }
}
</script>

<style>
  #card-params-rcp .v-card--material__heading{
    padding: 13px !important;
  }

  #card-params-rcp div div svg {
    height: 38px !important;
    width: 38px !important;
  }

  #card-params-rcp div div svg path {
    fill:#e93d1f !important;
  }
</style>